import React, { forwardRef, useImperativeHandle, useEffect } from 'react';
import { useFormik } from 'formik';
import { Box, FormGroup, FormControlLabel, Checkbox, Typography, Stack } from '@mui/material';
import { TextFieldCustom } from '../helpers/formFields';

// const slides = ['Value by Customer segment', 'Value for each Customer segment'];

const ContentForm = forwardRef(({ slides, presentation, onSubmit }, ref) => {
  // Validation function ensures at least one slide is selected
  const validate = (values) => {
    const errors = {};
    if (!values.title) {
      errors.title = 'A title is needed';
    }
    if (!values.slides || values.slides.length === 0) {
      errors.slides = 'At least one content type is needed';
    }
    return errors;
  };

  const initialValues = {
    title: presentation?.title || '',
    slides: presentation?.slides || [],
  };

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit,
  });

  useEffect(() => {
    formik.setFieldValue('title', presentation?.title || '')
    formik.setFieldValue('slides', presentation?.slides || [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [presentation])

  // Expose handleSubmit to parent via ref
  useImperativeHandle(ref, () => ({
    handleSubmit: formik.handleSubmit,
  }));

  return (
    <Box component="form" onSubmit={formik.handleSubmit} sx={{ width: 400, p: 2 }}>
      <Stack direction="column">
        <Typography variant="caption">Title</Typography>
        <TextFieldCustom
          name="title"
          value={formik.values.title}
          onChange={formik.handleChange}
          size="small"
          onBlur={formik.handleBlur}
          error={formik.touched.title && Boolean(formik.errors.title)}
          helperText={formik.touched.title && formik.errors.title}
        />
      </Stack>
      <Stack direction="column" sx={{ mt: 5 }}>
        <Typography variant="caption">Content</Typography>
        <FormGroup>
          {slides.map((slide, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  name="slides"
                  value={slide.id}
                  checked={formik.values.slides.includes(slide.id)}
                  onChange={(e) => {
                    const { checked, value } = e.target;
                    let newSlides = [...formik.values.slides];
                    if (checked) {
                      newSlides.push(value);
                    } else {
                      newSlides = newSlides.filter((item) => item !== value);
                    }
                    formik.setFieldValue('slides', newSlides);
                  }}
                />
              }
              label={
                <Typography
                  display="flex"
                  alignItems="center"
                >
                  {slide.icon}
                  <span style={{ marginLeft: 4 }}>{slide.slide}</span>
                </Typography>
              }
            />
          ))}
        </FormGroup>
        {formik.errors.slides && formik.submitCount > 0 && (
          <Typography variant="caption" color="error">
            {formik.errors.slides}
          </Typography>
        )}
      </Stack>
    </Box>
  );
});

export default ContentForm;
